<template>
  <div class="flex flex-col items-center overflow-auto">
    <h2 id="anstallda-header" class="type-heading-sm my-sm text-center font-bold">
      Mina ärenden anställda
    </h2>
    <div v-if="store.error">{{ store.error }}</div>
    <avtalat-spinner v-if="store.isLoading" />
    <div id="anstallda-open-container" class="w-3/5" v-if="!store.isLoading && !store.error">
      <AnstalldarendenTable
        title="Öppna ärenden"
        :columns="headingsOpenArenden"
        :arenden="store.getOpenArenden"
        :isLoading="store.openAnstalldarenden.isLoading"
        :canFetchMoreArenden="store.getCanFetchMoreOpenArenden"
        :fetch="() => store.fetchAnstalldarenden(true, api)"
        :sorted-by-created-at="false"
      />
    </div>
    <div id="anstallda-closed-container" class="w-3/5" v-if="!store.isLoading && !store.error">
      <AnstalldarendenTable
        title="Stängda ärenden"
        :columns="headingsClosedArenden"
        :arenden="store.getClosedArenden"
        :isLoading="store.closedAnstalldarenden.isLoading"
        :canFetchMoreArenden="store.getCanFetchMoreClosedArenden"
        :fetch="() => store.fetchAnstalldarenden(false, api)"
        :sorted-by-created-at="true"
      />
    </div>
    <div class="mt-md list-item h-sm w-full bg-white"></div>
    <h2 id="arbetsgivare-header" class="type-heading-sm my-sm text-center font-bold">
      Mina ärenden arbetsgivare
    </h2>
    <div v-if="store.error">{{ store.error }}</div>
    <avtalat-spinner v-if="store.isLoading" />
    <div id="arbetsgivare-open-container" class="w-3/5" v-if="!store.isLoading && !store.error">
      <ArbetsgivarearendenTable
        title="Öppna ärenden"
        :columns="headingsOpenArenden"
        :arenden="store.openArbetsgivarearenden.arenden"
        :isLoading="store.openArbetsgivarearenden.isLoading"
        :canFetchMoreArenden="!!store.openArbetsgivarearenden.nextLink"
        :fetch="() => store.fetchArbetsivarearenden(true, api)"
        :sorted-by-created-at="false"
      />
    </div>
    <div id="arbetsgivare-closed-container" class="mb-lg w-3/5" v-if="!store.isLoading && !store.error">
      <ArbetsgivarearendenTable
        title="Stängda ärenden"
        :columns="headingsClosedArenden"
        :arenden="store.closedArbetsgivarearenden.arenden"
        :isLoading="store.closedArbetsgivarearenden.isLoading"
        :canFetchMoreArenden="!!store.closedArbetsgivarearenden.nextLink"
        :fetch="() => store.fetchArbetsivarearenden(false, api)"
        :sorted-by-created-at="true"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCircleQuestion,
  faComments,
  faDatabase,
  faDesktop,
  faEnvelope,
  faHeadset,
  faPhone,
  faUser,
} from "@fortawesome/pro-regular-svg-icons";
import { onBeforeMount } from "vue";

import { useApi } from "@/composables/useApi";

import AnstalldarendenTable from "./AnstalldarendenTable.vue";
import ArbetsgivarearendenTable from "./ArbetsgivarearendenTable.vue";
import { useMinaArendenStore } from "./minaArendenStore";

library.add(
  faPhone,
  faEnvelope,
  faComments,
  faHeadset,
  faUser,
  faCircleQuestion,
  faDatabase,
  faDesktop,
);

const api = useApi();
const store = useMinaArendenStore();

onBeforeMount(() => {
  store.initFetch(api);
});

const headingsOpenArenden = [
  { content: "Kontaktorsak", disableSorting: true },
  { content: "Ärendenummer", disableSorting: true },
  { content: "Överlämnat till", disableSorting: true },
  { content: "Senast ändrat", disableSorting: true },
  { content: "Kanal", disableSorting: true },
];

const headingsClosedArenden = [
  { content: "Kontaktorsak", disableSorting: true },
  { content: "Ärendenummer", disableSorting: true },
  { content: "Överlämnat till", disableSorting: true },
  { content: "Skapat den", disableSorting: true },
  { content: "Kanal", disableSorting: true },
];
</script>